import React from 'react';
import AppRoutes from '_/space-management/navigation/AppRoutes';
import { DefaultTheme } from '@react-navigation/native';
import { useAuth } from '_/space-management/hooks/AuthContext';
import { useOrganizationContext } from '_/space-management/hooks/OrganizationContext';
import AuthLoading from '../screens/Signin/AuthLoading';
import OrganizationDisabledStackScreen from './OrganizationDisabledStackScreen';

export const MyTheme = {
  ...DefaultTheme,
  colors: {
    ...DefaultTheme.colors,
    background: '#FFFF',
  },
};

export function SpaceManagementRoutes() {
  const { member, authLoading } = useAuth();
  const { organizationData, isLoadingOrganization } = useOrganizationContext();

  if (authLoading || isLoadingOrganization) {
    return <AuthLoading />; 
  }
  
  if (member && organizationData?.active) {
    return <AppRoutes />;
  }

  return <OrganizationDisabledStackScreen />;
}
